export default "__VITE_ASSET__dcf0e449__"